import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { ExtractionTaskDetailPage } from "@client/components/doc-center/extraction-task/extraction-task-detail-page";

export const Route = createFileRoute("/_app/data-center/extraction/$taskId")({
  validateSearch: z.object({ fileId: z.string().optional(), returnTo: z.string().optional() }),
  component: ExtractionDetailRoute,
});

function ExtractionDetailRoute() {
  const { taskId } = Route.useParams();
  const { fileId, returnTo } = Route.useSearch();
  return <ExtractionTaskDetailPage key={`${taskId}:${fileId ?? ""}`} taskId={taskId} fileId={fileId} returnTo={returnTo} />;
}
